import { createSelector } from 'reselect';

import type { DeviceNavNode, DeviceNavTab } from 'src/service/api/deviceNav';

export const getDeviceNavState = (state) =>
  state.deviceNav;

export const getDeviceNavTab = createSelector(
  [getDeviceNavState],
  (deviceNav): DeviceNavTab | null => deviceNav.get('tab')
);

export const getDeviceNavItems = createSelector(
  [getDeviceNavState],
  (deviceNav): DeviceNavNode[] => deviceNav.get('items')
);

export const getDeviceNavTotal = createSelector(
  [getDeviceNavState],
  (deviceNav): number | null => deviceNav.get('total')
);

export const getDeviceNavLoading = createSelector(
  [getDeviceNavState],
  (deviceNav): boolean => deviceNav.get('loading')
);

export const getDeviceNavError = createSelector(
  [getDeviceNavState],
  (deviceNav) => deviceNav.get('error')
);
